module.exports = __webpack_public_path__ + "img/35.b4d44870.jpg";